import { c as _c } from "react/compiler-runtime";
import { useStreamedProjects } from "@hooks/projects/use-streamed-projects";
import { sortProjects } from "@utils/project-utils";
import { matchesAnySearchWord } from "@utils/string-utils";
/** All the projects arrive at once, so there is never a next page to load */
function loadNoMoreProjects() {
  // Nothing to load
}

/**
 * Lists the projects that pass filters the API cannot apply. They are taken from the projects
 * stream, which the map view shares, so the stream is fetched only once however often the user
 * switches between the views or changes the filters. Searching and sorting happen client-side too.
 */
export function useFilteredStreamedProjects(t0) {
  const $ = _c(13);
  const {
    companyId,
    projectArchivingState,
    sortBy,
    search,
    filterProjects,
    isEnabled
  } = t0;
  let t1;
  if ($[0] !== companyId || $[1] !== isEnabled || $[2] !== projectArchivingState) {
    t1 = {
      companyId,
      projectArchivingState,
      isEnabled
    };
    $[0] = companyId;
    $[1] = isEnabled;
    $[2] = projectArchivingState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    projects: allProjects,
    fetchingStatus
  } = useStreamedProjects(t1);
  let t2;
  if ($[4] !== allProjects || $[5] !== filterProjects || $[6] !== search || $[7] !== sortBy) {
    const searchedProjects = search ? allProjects.filter(project => matchesAnySearchWord(project.name, search)) : allProjects;
    t2 = sortProjects(filterProjects(searchedProjects), sortBy);
    $[4] = allProjects;
    $[5] = filterProjects;
    $[6] = search;
    $[7] = sortBy;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const projects = t2;
  const t3 = fetchingStatus === "uninitialized" || fetchingStatus === "pending";
  const t4 = fetchingStatus === "succeeded" || fetchingStatus === "rejected";
  let t5;
  if ($[9] !== projects || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      projects,
      isFetchingProjects: t3,
      hasFetchedFirstPage: t4,
      nextPageCursor: undefined,
      loadMoreProjects: loadNoMoreProjects,
      totalCount: projects.length
    };
    $[9] = projects;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}